
import {INotificationFilterTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationFilterTypeStrategy'
import {INotificationResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {NotificationFilterType} from '@toolify/server/src/controllers/NotificationController/enum/NotificationFilterType'
import {NotificationType, MENTION_NOTIFICATION_TYPES} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'

export class MentionsNotificationFilterTypeStrategy implements INotificationFilterTypeStrategy {
  updateNotificationsByNotificationFilterTypeMap(notificationsByNotificationFilterTypeMap: Map<NotificationFilterType, INotificationResponseInstance<NotificationType>[]>): Map<NotificationFilterType, INotificationResponseInstance<NotificationType>[]> {
    const newMap = new Map(notificationsByNotificationFilterTypeMap)
    const unreadNotifications = newMap.get(NotificationFilterType.Unread) || []
    const mentionedInMessageNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.Mentions) || []
    const allNotifications = notificationsByNotificationFilterTypeMap.get(NotificationFilterType.All) || []
    const updatedUnreadNotifications = unreadNotifications.map(notification => {
      if (!notification.readAt && MENTION_NOTIFICATION_TYPES.includes(notification.type)) {
        notification.readAt = new Date()
        notification.unreadGroupCount = 0
      }
      return notification
    })
    const updatedMentionedInMessageNotifications = mentionedInMessageNotifications.map(notification => {
      if (!notification.readAt) {
        notification.readAt = new Date()
        notification.unreadGroupCount = 0
      }
      return notification
    })
    const updatedAllNotifications = allNotifications.map(notification => {
      if (!notification.readAt && MENTION_NOTIFICATION_TYPES.includes(notification.type)) {
        notification.readAt = new Date()
        notification.unreadGroupCount = 0
      }
      return notification
    })

    newMap.set(NotificationFilterType.Unread, updatedUnreadNotifications)
    if (notificationsByNotificationFilterTypeMap.has(NotificationFilterType.Mentions)) {
      newMap.set(NotificationFilterType.Mentions, updatedMentionedInMessageNotifications)
    }
    if (notificationsByNotificationFilterTypeMap.has(NotificationFilterType.All)) {
      newMap.set(NotificationFilterType.All, updatedAllNotifications)
    }
    return newMap
  }
  isNotificationMatchingFilterType(notification: INotificationResponseInstance<NotificationType>): boolean {
    return MENTION_NOTIFICATION_TYPES.includes(notification.type)
  }
}
